"use strict";
// The Profile screen (UI Prompt Package 4.21). Four real editors now —
// display name, language, region and the avatar. The first three save
// through the one PATCH /me, which is a genuine partial update, so the
// form sends only what actually changed.
//
// The avatar is a real upload: POST /me/avatar with the bytes, served back
// from GET /me/avatar. It belongs to the Flix Account, not the Shopify
// customer. There is no storage URL anywhere in it — the endpoint serves
// whatever the current session's account holds, so there is nothing that
// names a file and nothing to sign. When no avatar is set the initials are
// not a fallback but the correct rendering, and the profile says which it
// is (`avatarUpdatedAt`) before the Hub asks for an image at all.
//
// The checks below duplicate the backend's on purpose: type and size are
// caught here so an obvious reject costs nobody a round trip. They are not
// the enforcement — the backend reads the magic bytes and is the only
// thing that decides what gets stored.
//
// The language and region choices are NOT a list this file invents.
// They come from Shopify's own `localization` object, rendered into
// data-store-languages / data-store-regions by sections/account-hub.liquid,
// so the options are exactly the languages and countries the store
// really supports. A store that publishes neither gets the read-only
// rows back rather than a dropdown that promises a choice nobody can
// honour.
//
// Client-side validation mirrors the backend rule exactly; a backend 400
// (IDENTITY.INVALID_DISPLAY_NAME) lands on the same field error, and a
// 401 is handled transparently by FlixAuthClient's existing refresh flow
// like every other call.
(function () {
    var bound = false;
    var MAX_DISPLAY_NAME_LENGTH = 60;
    var ARROW_BACK_ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>';
    /** Same two marks the Settings rows use, so the moved Email row is identical to the ones it left. */
    var MAIL_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="m3.5 7 8.5 6 8.5-6"/></svg>';
    var CAMERA_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>';
    var CHEVRON_ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    function t(hubEl, key, fallback) {
        return hubEl.dataset[key] || fallback;
    }
    function isFlixApiError(err) {
        return typeof err === "object" && err !== null && "status" in err && "code" in err;
    }
    /** Real values from GET /me rendered through Intl.DisplayNames in the UI's own language — standard browser API over real data, with the raw code as the fallback, never an invented label. */
    function displayNameOf(kind, code, uiLocale) {
        try {
            var resolved = new Intl.DisplayNames([uiLocale], { type: kind }).of(kind === "region" ? code.toUpperCase() : code);
            return resolved || code;
        }
        catch (err) {
            return code;
        }
    }
    /**
     * The store's real published languages or countries, as Liquid wrote
     * them. Anything unreadable yields an empty list, which the caller
     * treats as "no choice to offer" rather than substituting one.
     */
    function storeOptions(hubEl, key) {
        var raw = hubEl.dataset[key];
        if (!raw)
            return [];
        try {
            var parsed = JSON.parse(raw);
            if (!Array.isArray(parsed))
                return [];
            var out = [];
            for (var i = 0; i < parsed.length; i++) {
                var entry = parsed[i];
                if (typeof entry.code === "string" && entry.code) {
                    out.push({
                        code: entry.code,
                        label: typeof entry.label === "string" && entry.label ? entry.label : entry.code,
                    });
                }
            }
            return out;
        }
        catch (err) {
            return [];
        }
    }
    /**
     * Builds the option list, guaranteeing the account's CURRENT value is
     * among them.
     *
     * A value stored before the store changed its markets, or derived from
     * a browser that asked for a language the store never published, is
     * still what this account has. Dropping it would make the control show
     * a different value than the one in the database — and a save would
     * then silently change a preference nobody touched.
     */
    function optionsIncludingCurrent(options, current, kind, uiLocale) {
        var normalized = kind === "region" ? current.toUpperCase() : current.toLowerCase();
        for (var i = 0; i < options.length; i++) {
            var candidate = options[i];
            if (!candidate)
                continue;
            var code = kind === "region" ? candidate.code.toUpperCase() : candidate.code.toLowerCase();
            if (code === normalized)
                return options;
        }
        return [{ code: normalized, label: displayNameOf(kind, normalized, uiLocale) }].concat(options);
    }
    function selectFieldHtml(input) {
        var normalized = input.kind === "region" ? input.current.toUpperCase() : input.current.toLowerCase();
        var optionsHtml = "";
        for (var i = 0; i < input.options.length; i++) {
            var option = input.options[i];
            if (!option)
                continue;
            var code = input.kind === "region" ? option.code.toUpperCase() : option.code.toLowerCase();
            optionsHtml +=
                '<option value="' +
                    window.FlixHubFormat.escapeHtml(code) +
                    '"' +
                    (code === normalized ? ' selected' : "") +
                    ">" +
                    window.FlixHubFormat.escapeHtml(option.label) +
                    "</option>";
        }
        return ("<div>" +
            '<label for="' +
            input.id +
            '" style="display:block;font-size:13px;font-weight:700;color:var(--dim);margin-bottom:8px">' +
            window.FlixHubFormat.escapeHtml(input.label) +
            "</label>" +
            '<select id="' +
            input.id +
            '" name="' +
            input.name +
            '" style="width:100%;height:50px;padding:0 16px;border-radius:var(--radius-button);border:1px solid var(--border);' +
            "background:var(--bg2);color:var(--text);font-size:15px;font-family:var(--body);cursor:pointer;" +
            'transition:border-color .2s,box-shadow .2s;outline:none" style-focus="border-color:var(--accent);box-shadow:0 0 0 4px var(--glow)">' +
            optionsHtml +
            "</select>" +
            "</div>");
    }
    /**
     * Language and region: editable where the store really offers a
     * choice, read-only facts where it does not.
     *
     * The fallback matters. A store with a single published language has
     * nothing to pick from, and a one-option dropdown that cannot change
     * anything is worse than plainly showing the value — so that case
     * renders the same read-only rows this screen has always had, minus
     * the Coming-soon badge, which is no longer true of either field.
     */
    function localizationFieldsHtml(hubEl, profile, uiLocale) {
        var languages = optionsIncludingCurrent(storeOptions(hubEl, "storeLanguages"), profile.locale, "language", uiLocale);
        var regions = optionsIncludingCurrent(storeOptions(hubEl, "storeRegions"), profile.region, "region", uiLocale);
        var html = "";
        html +=
            languages.length > 1
                ? selectFieldHtml({
                    id: "flix-profile-locale",
                    name: "locale",
                    label: t(hubEl, "i18nProfileLocale", "Language"),
                    options: languages,
                    current: profile.locale,
                    kind: "language",
                })
                : staticFieldHtml(t(hubEl, "i18nProfileLocale", "Language"), displayNameOf("language", profile.locale, uiLocale));
        html +=
            regions.length > 1
                ? selectFieldHtml({
                    id: "flix-profile-region",
                    name: "region",
                    label: t(hubEl, "i18nProfileRegion", "Region"),
                    options: regions,
                    current: profile.region,
                    kind: "region",
                })
                : staticFieldHtml(t(hubEl, "i18nProfileRegion", "Region"), displayNameOf("region", profile.region, uiLocale));
        html +=
            '<p style="margin:-4px 0 0;font-size:12px;color:var(--faint);line-height:1.5">' +
                window.FlixHubFormat.escapeHtml(t(hubEl, "i18nProfileLocaleHint", "Used for the emails we send you and how prices and dates are shown.")) +
                "</p>";
        return html;
    }
    /** A field that shows a real value the store gives no way to change. */
    function staticFieldHtml(label, value) {
        return ("<div>" +
            '<span style="display:block;font-size:13px;font-weight:700;color:var(--dim);margin-bottom:8px">' +
            window.FlixHubFormat.escapeHtml(label) +
            "</span>" +
            '<div style="width:100%;min-height:50px;display:flex;align-items:center;padding:0 16px;border-radius:var(--radius-button);border:1px solid var(--border);background:var(--surface2);color:var(--text);font-size:15px">' +
            window.FlixHubFormat.escapeHtml(value) +
            "</div>" +
            "</div>");
    }
    /**
     * What an avatar may be, restated on this side of the wire.
     *
     * The backend is the authority — it reads the magic bytes and refuses
     * anything whose claim does not match them, which nothing here can do.
     * These two values exist so that picking a 4 MB screenshot or a GIF says
     * so immediately instead of after an upload, and they are kept equal to
     * the domain's on purpose.
     */
    var AVATAR_MAX_BYTES = 256 * 1024;
    var AVATAR_TYPES = ["image/png", "image/jpeg", "image/webp"];
    /**
     * The URL to draw, for any of the four sources.
     *
     * `default` resolves here rather than on the server: the store logo is a
     * theme asset whose path is a theme setting, rendered into
     * data-default-avatar-url by sections/account-hub.liquid. A store with no
     * logo configured yields an empty string, and the initials underneath are
     * then what shows -- which is the last fallback, not an error.
     */
    function effectiveAvatarUrl(hubEl, avatar) {
        if (avatar.source === "default")
            return hubEl.dataset.defaultAvatarUrl || "";
        return avatar.url || "";
    }
    function avatarBlockHtml(hubEl, profile) {
        var esc = window.FlixHubFormat.escapeHtml;
        var initials = esc(window.FlixHubFormat.initials(profile.displayName));
        var avatar = window.FlixHubFormat.resolvedAvatar(profile);
        var url = effectiveAvatarUrl(hubEl, avatar);
        // Only an upload can be removed. A provider picture is not ours to
        // delete, and the store logo is not a thing anybody set.
        var hasCustom = avatar.source === "custom";
        // The image sits OVER the initials rather than instead of them. If it
        // fails to load -- offline, a provider CDN having a moment, a logo asset
        // that moved -- what is uncovered is a correct avatar rather than an
        // empty circle. "The image broke" and "there is no image" should look
        // the same to whoever is looking at it.
        var imageHtml = url
            ? '<img data-flix-avatar-image data-avatar-source="' +
                esc(avatar.source) +
                '" alt="" src="' +
                esc(url) +
                '" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:50%">'
            : "";
        return ('<div style="position:relative;width:56px;height:56px;flex:none">' +
            '<button type="button" data-flix-avatar-pick aria-label="' +
            esc(t(hubEl, "i18nAvatarChange", "Change your profile picture")) +
            '" style="position:relative;display:flex;align-items:center;justify-content:center;width:56px;height:56px;padding:0;overflow:hidden;' +
            "border-radius:50%;background:var(--surface2);border:1px solid var(--border);cursor:pointer;" +
            'font-family:var(--display);font-weight:800;font-size:20px;color:var(--accent)" ' +
            'style-hover="border-color:var(--borderHi)">' +
            '<span data-flix-profile-avatar>' +
            initials +
            "</span>" +
            imageHtml +
            "</button>" +
            // Decorative: the button above already carries the label, so a second
            // announcement of the same control would only be noise.
            '<span aria-hidden="true" style="position:absolute;inset-inline-end:-3px;bottom:-3px;width:26px;height:26px;border-radius:50%;' +
            "background:linear-gradient(135deg,var(--accent),var(--accent2));color:#160d05;display:flex;align-items:center;justify-content:center;" +
            'border:2px solid var(--bg2);pointer-events:none">' +
            CAMERA_ICON +
            "</span>" +
            "</div>" +
            // Outside the profile form on purpose: the form's dirty-tracking
            // listens for change events on its own fields, and a file picker is
            // not a field that Save should light up for. The avatar saves itself.
            '<input type="file" data-flix-avatar-input accept="' +
            AVATAR_TYPES.join(",") +
            '" hidden>' +
            '<div data-flix-avatar-error hidden role="alert" style="font-size:13px;color:var(--error);text-align:center;max-width:280px"></div>' +
            (hasCustom
                ? '<button type="button" data-flix-avatar-remove style="background:none;border:none;padding:4px;font-family:var(--body);font-size:13px;color:var(--dim);cursor:pointer" style-hover="color:var(--error)">' +
                    esc(t(hubEl, "i18nAvatarRemove", "Remove picture")) +
                    "</button>"
                : ""));
    }
    function showAvatarError(message) {
        var el = document.querySelector("[data-flix-avatar-error]");
        if (!el)
            return;
        el.textContent = message;
        el.hidden = false;
    }
    function clearAvatarError() {
        var el = document.querySelector("[data-flix-avatar-error]");
        if (!el)
            return;
        el.textContent = "";
        el.hidden = true;
    }
    function setAvatarBusy(busy) {
        var button = document.querySelector("[data-flix-avatar-pick]");
        if (!button)
            return;
        button.style.opacity = busy ? "0.55" : "";
        button.style.cursor = busy ? "wait" : "pointer";
        if (busy)
            button.setAttribute("disabled", "true");
        else
            button.removeAttribute("disabled");
    }
    /** The backend's error codes, in words a person can act on. */
    function avatarErrorMessage(hubEl, err) {
        var code = isFlixApiError(err) ? err.code : "";
        switch (code) {
            case "IDENTITY.AVATAR_TOO_LARGE":
                return t(hubEl, "i18nAvatarTooLarge", "That picture is too large. The limit is 256 KB.");
            case "IDENTITY.AVATAR_UNSUPPORTED_TYPE":
            case "IDENTITY.AVATAR_TYPE_MISMATCH":
            case "IDENTITY.AVATAR_CORRUPT":
                return t(hubEl, "i18nAvatarBadType", "Choose a PNG, JPEG or WebP image.");
            case "IDENTITY.AVATAR_DIMENSIONS_OUT_OF_RANGE":
                return t(hubEl, "i18nAvatarBadSize", "Each side of the picture must be between 32 and 2048 pixels.");
            default:
                return t(hubEl, "i18nAvatarError", "Couldn't save your picture. Please try again.");
        }
    }
    function onAvatarPick(e) {
        var _a, _b;
        var button = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, "[data-flix-avatar-pick]");
        if (!button)
            return;
        var input = document.querySelector("[data-flix-avatar-input]");
        if (!input)
            return;
        clearAvatarError();
        input.click();
    }
    async function onAvatarChosen(e) {
        var input = e.target;
        if (!(input instanceof HTMLInputElement) || !input.matches("[data-flix-avatar-input]"))
            return;
        var file = input.files && input.files[0];
        // Reset immediately, so picking the same file twice in a row still
        // fires a change event the second time.
        input.value = "";
        if (!file)
            return;
        var hubEl = document.getElementById("flix-account-hub-root");
        if (!hubEl)
            return;
        clearAvatarError();
        if (AVATAR_TYPES.indexOf(file.type) === -1) {
            showAvatarError(t(hubEl, "i18nAvatarBadType", "Choose a PNG, JPEG or WebP image."));
            return;
        }
        if (file.size === 0 || file.size > AVATAR_MAX_BYTES) {
            showAvatarError(t(hubEl, "i18nAvatarTooLarge", "That picture is too large. The limit is 256 KB."));
            return;
        }
        setAvatarBusy(true);
        try {
            // The response IS the newly resolved avatar, so the screen is redrawn
            // from the server's own answer rather than from a guess — which is
            // what brings the Remove button into existence on a first upload and
            // points the image at the new object.
            var result = await window.FlixAuthClient.uploadAvatar(file);
            rerenderWithAvatar(hubEl, result);
            var feedbackEl = document.querySelector("[data-flix-profile-feedback]");
            if (feedbackEl) {
                feedbackEl.innerHTML =
                    '<div style="margin-bottom:16px">' +
                        window.FlixHubRender.successState({
                            title: t(hubEl, "i18nAvatarSavedTitle", "Picture updated"),
                            message: t(hubEl, "i18nAvatarSavedMessage", "Your new profile picture has been saved."),
                        }) +
                        "</div>";
            }
        }
        catch (err) {
            setAvatarBusy(false);
            showAvatarError(avatarErrorMessage(hubEl, err));
        }
    }
    async function onAvatarRemove(e) {
        var _a, _b;
        var button = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, "[data-flix-avatar-remove]");
        if (!button)
            return;
        var hubEl = document.getElementById("flix-account-hub-root");
        if (!hubEl)
            return;
        clearAvatarError();
        setAvatarBusy(true);
        try {
            // Not necessarily back to initials: removing an upload uncovers the
            // provider picture when there is one, and the response says which.
            var resolved = await window.FlixAuthClient.removeAvatar();
            rerenderWithAvatar(hubEl, resolved);
        }
        catch (err) {
            setAvatarBusy(false);
            showAvatarError(avatarErrorMessage(hubEl, err));
        }
    }
    /**
     * The profile this screen was last drawn from.
     *
     * Held so that changing the avatar can re-render without a second
     * GET /me: the upload and remove responses already carry the new resolved
     * avatar, and nothing else on the screen has changed. One request per
     * action instead of two, and no window where the two disagree.
     */
    var lastProfile = null;
    /** Re-draws the screen with a new avatar and nothing else altered. */
    function rerenderWithAvatar(hubEl, avatar) {
        var contentEl = document.querySelector("[data-flix-hub-content]");
        if (!contentEl || !lastProfile)
            return;
        render(hubEl, contentEl, { ...lastProfile, avatar: avatar });
        window.flixCompileHoverStyles(contentEl);
    }
    function render(hubEl, contentEl, profile) {
        lastProfile = profile;
        var uiLocale = document.documentElement.lang || "en";
        var savedName = profile.displayName || "";
        var headerName = profile.displayName || t(hubEl, "i18nUnnamed", "Flix Member");
        contentEl.innerHTML =
            '<div style="max-width:520px">' +
                '<button type="button" data-flix-hub-nav="settings" style="display:inline-flex;align-items:center;gap:8px;background:none;border:none;color:var(--dim);font-size:13px;font-weight:600;cursor:pointer;padding:0;margin-bottom:20px" style-hover="color:var(--text)">' +
                '<span aria-hidden="true" data-flix-hub-back-arrow style="display:flex">' +
                ARROW_BACK_ICON +
                "</span>" +
                window.FlixHubFormat.escapeHtml(t(hubEl, "i18nBackToSettings", "Back to settings")) +
                "</button>" +
                // 5.12's editable-density Profile Header: avatar above text, centered.
                // The edit affordance is real now, and the whole 56px circle is the
                // button rather than just the badge on it — a 26px target is below
                // what a thumb can reliably hit, and the badge is there to say the
                // circle is editable, not to be the thing you aim at.
                '<div style="display:flex;flex-direction:column;align-items:center;gap:10px;margin-bottom:26px">' +
                avatarBlockHtml(hubEl, profile) +
                '<div data-flix-profile-header-name style="font-family:var(--display);font-weight:800;font-size:20px;color:var(--text)">' +
                window.FlixHubFormat.escapeHtml(headerName) +
                "</div>" +
                "</div>" +
                '<div data-flix-profile-feedback></div>' +
                // The stored values ride along on the form, so "has anything
                // changed" is answered against what the account actually holds
                // rather than against whatever the controls happened to start at.
                '<form data-flix-profile-form novalidate data-saved-display-name="' +
                window.FlixHubFormat.escapeHtml(savedName) +
                '" data-saved-locale="' +
                window.FlixHubFormat.escapeHtml(profile.locale) +
                '" data-saved-region="' +
                window.FlixHubFormat.escapeHtml(profile.region) +
                '" style="display:flex;flex-direction:column;gap:16px">' +
                "<div>" +
                '<label for="flix-profile-display-name" style="display:block;font-size:13px;font-weight:700;color:var(--dim);margin-bottom:8px">' +
                window.FlixHubFormat.escapeHtml(t(hubEl, "i18nProfileDisplayName", "Display name")) +
                "</label>" +
                '<input id="flix-profile-display-name" name="displayName" type="text" maxlength="' +
                MAX_DISPLAY_NAME_LENGTH +
                '" value="' +
                window.FlixHubFormat.escapeHtml(savedName) +
                '" style="width:100%;height:50px;padding:0 16px;border-radius:var(--radius-button);border:1px solid var(--border);background:var(--bg2);color:var(--text);font-size:15px;font-family:var(--body);transition:border-color .2s,box-shadow .2s;outline:none" style-focus="border-color:var(--accent);box-shadow:0 0 0 4px var(--glow)">' +
                '<div data-flix-profile-error hidden style="margin-top:8px;font-size:13px;color:var(--error)"></div>' +
                "</div>" +
                localizationFieldsHtml(hubEl, profile, uiLocale) +
                '<button type="submit" data-flix-profile-save data-label-default="' +
                window.FlixHubFormat.escapeHtml(t(hubEl, "i18nProfileSave", "Save")) +
                '" data-label-saving="' +
                window.FlixHubFormat.escapeHtml(t(hubEl, "i18nProfileSaving", "Saving…")) +
                // Starts disabled: nothing has been edited yet, so there is
                // nothing to save.
                '" disabled style="height:50px;border-radius:var(--radius-button);border:none;background:linear-gradient(135deg,var(--accent),var(--accent2));color:#160d05;font-family:var(--display);font-weight:800;font-size:14px;opacity:.45;cursor:default;box-shadow:0 8px 22px -8px var(--glow);transition:transform .2s" style-hover="transform:translateY(-2px)">' +
                window.FlixHubFormat.escapeHtml(t(hubEl, "i18nProfileSave", "Save")) +
                "</button>" +
                "</form>" +
                // Email is account identity, so it lives with Profile rather than on
                // the Settings router. Its own screen is unchanged; this is the way
                // in. Same row chrome as the Settings destinations it moved from.
                '<div data-flix-settings-group style="margin-top:14px;border-radius:var(--radius-md);background:var(--surface);border:1px solid var(--border);overflow:hidden">' +
                '<button type="button" data-flix-hub-nav="email" data-flix-settings-row ' +
                'style="width:100%;min-height:56px;display:flex;align-items:center;gap:12px;padding:0 16px;border:none;' +
                'background:transparent;text-align:start;font-size:14px;font-weight:600;color:var(--text);cursor:pointer;' +
                'transition:background .2s" style-hover="background:var(--surface2)">' +
                '<span aria-hidden="true" style="flex:none;color:var(--dim);display:flex">' +
                MAIL_ICON +
                "</span>" +
                '<span style="flex:1">' +
                window.FlixHubFormat.escapeHtml(t(hubEl, "i18nSettingsEmail", "Email")) +
                "</span>" +
                '<span aria-hidden="true" data-flix-hub-fwd-chevron style="flex:none;color:var(--faint);display:flex">' +
                CHEVRON_ICON +
                "</span>" +
                "</button>" +
                "</div>" +
                "</div>";
    }
    function setSaving(button, saving) {
        button.dataset.busy = saving ? "true" : "false";
        if (saving) {
            button.setAttribute("disabled", "true");
            button.style.opacity = "0.6";
            button.style.cursor = "wait";
            button.textContent = button.dataset.labelSaving || button.textContent || "";
        }
        else {
            button.removeAttribute("disabled");
            button.style.opacity = "";
            button.style.cursor = "pointer";
            button.textContent = button.dataset.labelDefault || button.textContent || "";
        }
    }
    function showFieldError(form, message) {
        var errorEl = form.querySelector("[data-flix-profile-error]");
        if (!errorEl)
            return;
        errorEl.textContent = message;
        errorEl.hidden = false;
    }
    function valueOf(form, name) {
        var field = form.querySelector('[name="' + name + '"]');
        return field ? field.value : null;
    }
    /**
     * Whether anything on the form differs from what is actually stored.
     *
     * The Save button follows this, so a click always means a real change.
     * Without it the only honest alternatives would be a request that
     * changes nothing, or a success message for a save that never
     * happened.
     */
    function isDirty(form) {
        var saved = form.dataset;
        var name = valueOf(form, "displayName");
        if (name !== null && name.trim() !== (saved.savedDisplayName || ""))
            return true;
        var locale = valueOf(form, "locale");
        if (locale !== null && locale !== saved.savedLocale)
            return true;
        var region = valueOf(form, "region");
        if (region !== null && region !== saved.savedRegion)
            return true;
        return false;
    }
    function setSaveEnabled(form, enabled) {
        var button = form.querySelector("[data-flix-profile-save]");
        if (!button || button.dataset.busy === "true")
            return;
        if (enabled) {
            button.removeAttribute("disabled");
            button.style.opacity = "";
            button.style.cursor = "pointer";
        }
        else {
            button.setAttribute("disabled", "true");
            button.style.opacity = "0.45";
            button.style.cursor = "default";
        }
    }
    function onFormChanged(e) {
        var _a, _b;
        var form = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, "[data-flix-profile-form]");
        if (!(form instanceof HTMLFormElement))
            return;
        setSaveEnabled(form, isDirty(form));
    }
    async function onSubmit(e) {
        var _a, _b;
        var form = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, "[data-flix-profile-form]");
        if (!(form instanceof HTMLFormElement))
            return;
        e.preventDefault();
        var hubEl = document.getElementById("flix-account-hub-root");
        var input = form.querySelector('input[name="displayName"]');
        var button = form.querySelector("[data-flix-profile-save]");
        var errorEl = form.querySelector("[data-flix-profile-error]");
        var feedbackEl = document.querySelector("[data-flix-profile-feedback]");
        if (!hubEl || !input || !button || button.hasAttribute("disabled"))
            return;
        if (errorEl)
            errorEl.hidden = true;
        if (feedbackEl)
            feedbackEl.innerHTML = "";
        // Only what actually changed goes on the wire. PATCH /me applies
        // exactly the fields it is given, so omitting the untouched ones is
        // what keeps this screen from re-saving preferences nobody edited.
        var patch = {};
        var trimmed = input.value.trim();
        if (trimmed !== (form.dataset.savedDisplayName || "")) {
            // Mirrors the backend's own DisplayName rule (1–60 after trimming)
            // so an obviously-invalid value never even leaves the browser; the
            // backend stays the actual authority via the 400 branch below.
            if (trimmed.length < 1 || trimmed.length > MAX_DISPLAY_NAME_LENGTH) {
                showFieldError(form, t(hubEl, "i18nProfileInvalid", "Display name must be 1–60 characters."));
                return;
            }
            patch.displayName = trimmed;
        }
        var locale = valueOf(form, "locale");
        if (locale !== null && locale !== form.dataset.savedLocale)
            patch.locale = locale;
        var region = valueOf(form, "region");
        if (region !== null && region !== form.dataset.savedRegion)
            patch.region = region;
        if (patch.displayName === undefined && patch.locale === undefined && patch.region === undefined) {
            setSaveEnabled(form, false);
            return;
        }
        setSaving(button, true);
        try {
            var result = await window.FlixAuthClient.updateProfile(patch);
            setSaving(button, false);
            // The response is the account as it now stands, so it — not the
            // values we happened to send — becomes the new baseline.
            var savedName = result.displayName || "";
            form.dataset.savedDisplayName = savedName;
            form.dataset.savedLocale = result.locale;
            form.dataset.savedRegion = result.region;
            input.value = savedName;
            setSaveEnabled(form, false);
            var headerNameEl = document.querySelector("[data-flix-profile-header-name]");
            if (headerNameEl) {
                headerNameEl.textContent = savedName || t(hubEl, "i18nUnnamed", "Flix Member");
            }
            var avatarEl = document.querySelector("[data-flix-profile-avatar]");
            if (avatarEl)
                avatarEl.textContent = window.FlixHubFormat.initials(result.displayName);
            if (feedbackEl) {
                var onlyName = patch.locale === undefined && patch.region === undefined;
                feedbackEl.innerHTML =
                    '<div style="margin-bottom:16px">' +
                        window.FlixHubRender.successState({
                            title: t(hubEl, "i18nProfileSavedTitle", "Profile updated"),
                            message: onlyName
                                ? t(hubEl, "i18nProfileSavedMessage", "Your display name has been saved.")
                                : t(hubEl, "i18nProfileSavedMessagePrefs", "Your profile has been saved."),
                        }) +
                        "</div>";
            }
        }
        catch (err) {
            setSaving(button, false);
            setSaveEnabled(form, isDirty(form));
            if (isFlixApiError(err) && err.status === 400 && err.code === "IDENTITY.INVALID_DISPLAY_NAME") {
                showFieldError(form, t(hubEl, "i18nProfileInvalid", "Display name must be 1–60 characters."));
                return;
            }
            // A session expiry already navigated away via FlixAuthClient — this
            // generic message only ever shows for a still-usable page.
            showFieldError(form, t(hubEl, "i18nProfileError", "Couldn't save your changes. Please try again."));
        }
    }
    if (!bound) {
        bound = true;
        document.addEventListener("submit", onSubmit);
        document.addEventListener("click", onAvatarPick);
        document.addEventListener("click", onAvatarRemove);
        document.addEventListener("change", onAvatarChosen);
        document.addEventListener("input", onFormChanged);
        document.addEventListener("change", onFormChanged);
    }
    window.FlixHubProfile = { render: render };
})();
